import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import ActionCreators from '../actions';
import WebBooking from '../components/WebBooking';

function mapDispatchToProps(dispatch) {
  return bindActionCreators(ActionCreators, dispatch);
}

function mapStateToProps(state) {
  return {
    webbookingconfig: state.webbookingconfig,
    business: state.business,
    auth:state.auth
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(WebBooking);
